import { loadStaticPageSection } from '@/i18n/staticPageContent';
import type { PublishedLocaleManifest } from '@/i18n/types';

export const fetchPageSection = async <T>(
    manifest: PublishedLocaleManifest,
    locale: string,
    pageSlug: string,
    sectionKey: string,
): Promise<T | null> => {
    return loadStaticPageSection<T>(manifest, locale, pageSlug, sectionKey);
};
